(function () {
  'use strict';

  angular
      .module('tfc.retailer.FitConsistency')
      .factory('FitConsistencyReport', FitConsistencyReport);

  // @ngInject
  function FitConsistencyReport($q, util, Upload, ExcelReportType, GaUtil, Api) {

    return {
      downloadReport: downloadReport
    };

    function getFileContent(selectedHierarchy, selectedBrandKey, selectedDepartment, selectedCategory, selectedRegion,
                            selectedTransaction, sortField, sortOrder, isActivityExist, isRegionExist) {
      return $q.when(content(selectedHierarchy, selectedBrandKey, selectedDepartment, selectedCategory, selectedRegion,
          selectedTransaction, sortField, sortOrder, isActivityExist, isRegionExist))
          .then(function (content) {
            return content;
          });
    }

    function generateURL(hierarchy) {
      var BASE_URL = '/brand/report/consistency/';
      var path = hierarchy === 'All Categories' ? 'hierarchies' : 'sizeAdvice';
      return BASE_URL + path;
    }

    function content(selectedHierarchy, selectedBrandKey, selectedDepartment, selectedCategory, selectedRegion,
                     selectedTransaction, sortField, sortOrder, isActivityExist, isRegionExist) {

      return Api.get(generateURL(selectedHierarchy), {
        cache: false,
        params: {
          brandKey: selectedBrandKey,
          department: selectedDepartment,
          category: selectedCategory,
          region: selectedRegion,
          transaction: selectedTransaction,
          sortField: sortField,
          sortOrder: sortOrder,
          addTransactionHeader: isActivityExist,
          addRegionHeader: isRegionExist
        },
        responseType: 'arraybuffer',
        headers: {
          'Accept': ExcelReportType
        }
      }).then(function (response) {
        var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
        return $q.all({
          fileName: disposition.filename,
          dataBlob: new Blob([response.data], {type: disposition['content-type']})
        });
      });
    }

    function downloadReport(selectedHierarchy, selectedBrandKey, selectedDepartment, selectedCategory, selectedLocaleCode,
                            selectedTransaction, sortField, sortOrder, isActivityExist, isRegionExist) {
      return getFileContent(selectedHierarchy, selectedBrandKey, selectedDepartment, selectedCategory, selectedLocaleCode,
          selectedTransaction, sortField, sortOrder, isActivityExist, isRegionExist)
          .then(function (content) {
            download(content.dataBlob, content.fileName, ExcelReportType);
            GaUtil.sendGaEvent(selectedBrandKey, 'Download Report', 'Fit Consistency Report');
          });
    }

  }

})();